import {
  MercuryLiteConfigSchema,
  MercuryModelMode,
} from "@redotech/redo-model/conversion/mercury-model";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateMercuryModel = {
  name: "updateMercuryModel" as const,
  input: z.object({
    mercuryModelId: zExt.objectId(),
    assumedOrderMargin: z
      .object({
        percentage: z.number().optional(),
        fixed: z.number().optional(),
      })
      .optional(),
    mode: z.nativeEnum(MercuryModelMode).optional(),
    liteConfig: MercuryLiteConfigSchema.optional(),
  }),
  output: z.null(),
};
